<div class="bucket-header tab-quotes">
  <div class="headers">
    @for (bucketDetail of bucketDetails; track bucketDetail.bucketName) {
      <div
        class="bucket"
        (click)="scrollBucket.emit(bucketDetail?.bucketName)"
        [class.bucket-selected]="bucketSelected === bucketDetail?.bucketName">
        <div class="labels body-2">{{ bucketDetail?.label }}</div>
        <h6>{{ bucketDetail?.bucketLength }}</h6>
      </div>
    }
  </div>
  <section class="flex items-center">
    <div class="dates ml-10 mr-30">
      @if (dates?.oldestReceivedOn) {
        <div class="oldest-received">
          <div class="labels body-2">Oldest received on</div>
          <div class="date subtitle-2">
            {{ dates?.oldestReceivedOn | dateepoch: dates?.timezone }}
            {{ dates?.oldestReceivedOn | time: dates?.timezone }}
          </div>
        </div>
      }
      @if (dates?.newestReceivedOn) {
        <div>
          <div class="labels body-2">Newest received on</div>
          <div class="date subtitle-2">
            {{ dates?.newestReceivedOn | dateepoch: dates?.timezone }}
            {{ dates?.newestReceivedOn | time: dates?.timezone }}
          </div>
        </div>
      }
    </div>
    <div [matTooltip]="setUnreadJobsTooltipMessage()">
      <button
        matButton="filled"
        class="white-button border! border-solid! border-charcoal-80! p-0! size-40! min-w-40!"
        [ngClass]="{ 'border-b-4! border-b-red!': unreadJobFilter.isUnreadFilterActivated }"
        [disabled]="!unreadJobFilter.hasUnreadJobs && !unreadJobFilter.isUnreadFilterActivated"
        (click)="onClickUnreadFilterButton()">
        <mat-icon
          svgIcon="unread_job"
          class="m-0!"
          [ngClass]="{
            'contrast-0 opacity-50': !unreadJobFilter.hasUnreadJobs && !unreadJobFilter.isUnreadFilterActivated,
            '-mb-3!': unreadJobFilter.isUnreadFilterActivated
          }"></mat-icon>
      </button>
    </div>
  </section>
</div>
